var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.$_can("companies.customers.store")
          ? _c("div", { staticClass: "col-3 text-right" }, [
              _c("div", { staticClass: "dropdown dropdown-menu-right pr-3" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu dropdown-menu-right",
                    attrs: { "aria-labelledby": "dropdownMenuButton" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-box border-bottom pointer",
                        on: {
                          click: function($event) {
                            _vm.showCreateSidebar = !_vm.showCreateSidebar
                          }
                        }
                      },
                      [
                        _c("button", { staticClass: "dropdown-item" }, [
                          _vm._v("\n              Add Customer\n            ")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Add a single customer for the selected company."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-box border-bottom pointer",
                        on: {
                          click: function($event) {
                            _vm.showImportCustomers = !_vm.showImportCustomers
                          }
                        }
                      },
                      [
                        _c("button", { staticClass: "dropdown-item" }, [
                          _vm._v(
                            "\n              Import Customers\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Add multiple customers for the selected company from a file of your choosing."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-box border-bottom pointer",
                        on: { click: _vm.openExportModal }
                      },
                      [
                        _c("button", { staticClass: "dropdown-item" }, [
                          _vm._v(
                            "\n              Export Customers\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Export customers data for all, or selected, companies within a date range of your choice."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-box border-bottom pointer",
                        on: {
                          click: function($event) {
                            _vm.showRequestReviews = !_vm.showRequestReviews
                          }
                        }
                      },
                      [
                        _c("button", { staticClass: "dropdown-item" }, [
                          _vm._v(
                            "\n              Request reviews and optional import\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Select customers you wish to receive a review request for the selected company. With this option you can also import customers."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-box border-bottom pointer",
                        on: {
                          click: function($event) {
                            _vm.$router.push("customers/pending")
                          }
                        }
                      },
                      [
                        _c("button", { staticClass: "dropdown-item" }, [
                          _vm._v(
                            "\n              Pending requests\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Check the pending review requests you've sent and their status."
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 l-m-b-20" }, [
          _c("div", { staticClass: "input-group search" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.q,
                  expression: "q"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.q },
              on: {
                keyup: function($event) {
                  _vm.searchText($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.q = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn input-group-btn",
                attrs: { type: "button" },
                on: { click: _vm.clearSearch }
              },
              [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 filters-field" })
      ]),
      _vm._v(" "),
      !_vm.customers
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover l-m-t-20" }, [
              _c("thead", { staticClass: "m-table__heading" }, [
                _c("tr", [
                  _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "users.first_name" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("users.first_name")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Name\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["users.first_name"]
                          ? "dsc"
                          : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "users.email" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("users.email")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Email\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["users.email"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Phone")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Status")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.customers, function(customer) {
                    return _c(
                      "tr",
                      {
                        key: customer.id,
                        staticClass: "pointer",
                        on: {
                          mouseup: function($event) {
                            _vm.$_can("companies.customers.show") &&
                              _vm.view($event, customer.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(customer.id))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", [_vm._v(_vm._s(customer.first_name))]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(customer.last_name && customer.last_name)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(customer.email))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              customer.phone &&
                                _vm.phoneMask.maskedPhone(customer.phone)
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(customer.user_status.name))])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.customers && !_vm.customers.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "6" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.meta.total
                  ? _c("div", { staticClass: "col-sm-6 mb-1 text-black-50" }, [
                      _vm._v(
                        "\n        Showing " +
                          _vm._s(_vm.meta.from) +
                          " - " +
                          _vm._s(_vm.meta.to) +
                          " of " +
                          _vm._s(_vm.meta.total) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showCreateSidebar = false
                  }
                }
              },
              [
                _c("customers-create", {
                  staticClass: "sidebar-right",
                  on: {
                    cancel: function($event) {
                      _vm.showCreateSidebar = false
                    },
                    update: _vm.getCustomers
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showImportCustomers
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              !_vm.importLoading && !_vm.successfulImport
                ? [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", [_vm._v("Import Customers")])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c(
                        "form",
                        {
                          attrs: { enctype: "multipart/form-data" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.importCustomers($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row mb-4" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("span", { staticClass: "field-heading" }, [
                                _vm._v("select company")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Company")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: { options: _vm.companies },
                                    model: {
                                      value: _vm.companyId,
                                      callback: function($$v) {
                                        _vm.companyId = $$v
                                      },
                                      expression: "companyId"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-4" }, [
                            _c(
                              "div",
                              { staticClass: "col d-flex flex-column" },
                              [
                                _c("span", { staticClass: "field-heading" }, [
                                  _vm._v("file for import")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "custom-file-upload" },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-cloud-upload"
                                    }),
                                    _vm._v(" Upload file\n                "),
                                    _c("input", {
                                      ref: "customer_file",
                                      staticClass: "mt-2",
                                      attrs: {
                                        type: "file",
                                        accept:
                                          ".xls,.xlsx,.csv,.tsv,.ods,.slk,.xml"
                                      },
                                      on: { change: _vm.customerFile }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.uploadedFile && _vm.uploadedFile.length
                                  ? _c("span", { staticClass: "file-name" }, [
                                      _c("i", { staticClass: "fa fa-file" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.uploadedFile[0].name) +
                                          "\n              "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-4" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                { staticClass: "allowed-file-types mb-4" },
                                [
                                  _vm._v(
                                    "\n                Allowed file types are: CSV, XLSX, TSV, ODS, SLK, ODM, XML.\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "file-rules" }, [
                                _vm._v(
                                  "\n                File needs to contain 4 columns: first_name, last_name, email and phone.\n                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                Order of the columns is not important.\n                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                Phone number should be in 10 digit format with only numbers.\n                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                Last name is optional and can be blank.\n                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                Email or Phone is required. You can have one or the other, or both.\n              "
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row m-0" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 d-flex flex-column justify-content-center align-items-center p-0"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary ld-ext-right w-100",
                                    attrs: {
                                      type: "submit",
                                      disabled: _vm.isValid
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Import Customers\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "link pointer mt-3",
                                    on: { click: _vm.goToSendReviews }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Go to send reviews\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" })
                  ]
                : _vm.importLoading
                  ? [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column align-items-center justify-content-center mt-5"
                          },
                          [
                            _c("span", { staticClass: "loader-text" }, [
                              _vm._v("please wait")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "loader-heading mb-3" }, [
                              _vm._v("Customers are being imported.")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "loader" })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
                    ]
                  : _vm.successfulImport && !_vm.importLoading
                    ? [
                        _c("div", {
                          attrs: { slot: "header" },
                          slot: "header"
                        }),
                        _vm._v(" "),
                        _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-center mt-5 mb-4"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-row import-stats" },
                                [
                                  _c("div", { staticClass: "imported col-3" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.importResponse.imported) +
                                        " Imported\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "failed col-3" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.importResponse.failed) +
                                        " Failed\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "errors col-3" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.importResponse.errors) +
                                        " Errors\n            "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column mt-5 pl-0 col-12"
                                },
                                [
                                  _c("h4", [_vm._v("Failed cases")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "scrollable-body" },
                                    _vm._l(
                                      _vm.importResponse.failures,
                                      function(error, index) {
                                        return _c(
                                          "span",
                                          { key: index },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-bold pr-4"
                                              },
                                              [_vm._v("ROW " + _vm._s(index))]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(error, function(
                                              item,
                                              itemIndex
                                            ) {
                                              return _c(
                                                "span",
                                                { key: itemIndex },
                                                _vm._l(item, function(
                                                  failure,
                                                  failureIndex
                                                ) {
                                                  return _c(
                                                    "span",
                                                    { key: failureIndex },
                                                    [
                                                      _vm._v(
                                                        " " + _vm._s(failure)
                                                      )
                                                    ]
                                                  )
                                                })
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("br")
                                          ],
                                          2
                                        )
                                      }
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { attrs: { slot: "footer" }, slot: "footer" })
                      ]
                    : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showExportModal
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large" },
              on: { close: _vm.closeExportModal }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("\n        Select export parameters\n      ")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Company")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: { options: _vm.companies },
                          model: {
                            value: _vm.exportFilters.companyId,
                            callback: function($$v) {
                              _vm.$set(_vm.exportFilters, "companyId", $$v)
                            },
                            expression: "exportFilters.companyId"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Date")]),
                        _vm._v(" "),
                        _c("flat-pickr", {
                          staticClass: "simple-select-input",
                          attrs: {
                            config: _vm.config,
                            placeholder: "Select Date",
                            name: "date"
                          },
                          on: { "on-close": _vm.onCreatedDateChange },
                          model: {
                            value: _vm.exportFilters.created_at,
                            callback: function($$v) {
                              _vm.$set(_vm.exportFilters, "created_at", $$v)
                            },
                            expression: "exportFilters.created_at"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "container",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("div", { staticClass: "row mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "col d-flex justify-content-between" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: { click: _vm.exportCustomers }
                          },
                          [_vm._v("\n            Export\n          ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRequestReviews
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              !_vm.requestLoading &&
              !_vm.successfulRequest &&
              !_vm.importingRequests
                ? [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", [
                        _vm._v(
                          "\n          Send review request for old customers\n        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("span", { staticClass: "field-heading" }, [
                            _vm._v("select company")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "select-wrap" },
                            [
                              _c("label", [_vm._v("Company")]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: { options: _vm.companies },
                                model: {
                                  value: _vm.companyId,
                                  callback: function($$v) {
                                    _vm.companyId = $$v
                                  },
                                  expression: "companyId"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-4" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("span", { staticClass: "field-heading" }, [
                              _vm._v("customers")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.requestsToSend, function(field, index) {
                              return _c("div", { key: "em-" + index }, [
                                _c("div", { staticClass: "row mb-2" }, [
                                  _c("div", { staticClass: "col" }, [
                                    _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [_vm._v("First Name")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: field.first_name,
                                            expression: "field.first_name"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "false"
                                        },
                                        domProps: { value: field.first_name },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              field,
                                              "first_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col" }, [
                                    _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [_vm._v("Last Name")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: field.last_name,
                                            expression: "field.last_name"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "false"
                                        },
                                        domProps: { value: field.last_name },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              field,
                                              "last_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col" }, [
                                    _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [_vm._v("Email")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: field.email,
                                            expression: "field.email"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "email",
                                          autocomplete: "false"
                                        },
                                        domProps: { value: field.email },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              field,
                                              "email",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-1 pt-3" }, [
                                    index > 0 || _vm.requestsToSend.length !== 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "btn btn-clear",
                                            on: {
                                              click: function($event) {
                                                _vm.removeField(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-remove"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ])
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mt-2 mb-5" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "span",
                            {
                              staticClass: "btn add-button pointer mr-2",
                              on: { click: _vm.addField }
                            },
                            [
                              _c("span", [
                                _c("i", {
                                  staticClass: "fa fa-plus",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]),
                              _vm._v("Add one more\n            ")
                            ]
                          ),
                          _vm._v("\n            or use\n            "),
                          _c(
                            "span",
                            {
                              staticClass: "btn add-button pointer ml-2",
                              on: {
                                click: function($event) {
                                  _vm.importingRequests = true
                                }
                              }
                            },
                            [
                              _c("span", [
                                _c("i", {
                                  staticClass: "fa fa-plus",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]),
                              _vm._v("Import option\n            ")
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mt-5" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 d-flex flex-column justify-content-start"
                          },
                          [
                            _c("div", { staticClass: "check-field mb-2" }, [
                              _c(
                                "label",
                                {
                                  class: [{ "check-open": _vm.createCustomers }]
                                },
                                [
                                  _c("span", { staticClass: "checkmark" }),
                                  _vm._v(
                                    "Also create these customers and store them for selected Company\n                "
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.createCustomers,
                                        expression: "createCustomers"
                                      }
                                    ],
                                    staticClass: "btn-check",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: _vm.createCustomers,
                                      checked: Array.isArray(
                                        _vm.createCustomers
                                      )
                                        ? _vm._i(
                                            _vm.createCustomers,
                                            _vm.createCustomers
                                          ) > -1
                                        : _vm.createCustomers
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.createCustomers,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = _vm.createCustomers,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.createCustomers = $$a.concat(
                                                [$$v]
                                              ))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.createCustomers = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.createCustomers = $$c
                                        }
                                      }
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary w-100 send-button pull-right ld-ext-right",
                                on: { click: _vm.sendRequestReviews }
                              },
                              [_vm._v("\n              Send\n            ")]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" })
                  ]
                : !_vm.requestLoading &&
                  !_vm.successfulRequest &&
                  _vm.importingRequests
                  ? [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("h4", [
                          _vm._v(
                            "\n          Send review request for old customers\n        "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c(
                          "form",
                          {
                            attrs: { enctype: "multipart/form-data" },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.sendRequestReviewsWithFile($event)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("span", { staticClass: "field-heading" }, [
                                  _vm._v("select company")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "select-wrap" },
                                  [
                                    _c("label", [_vm._v("Company")]),
                                    _vm._v(" "),
                                    _c("simple-select", {
                                      attrs: { options: _vm.companies },
                                      model: {
                                        value: _vm.companyId,
                                        callback: function($$v) {
                                          _vm.companyId = $$v
                                        },
                                        expression: "companyId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c(
                                "div",
                                { staticClass: "col d-flex flex-column" },
                                [
                                  _c("span", { staticClass: "field-heading" }, [
                                    _vm._v("file for import")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "custom-file-upload" },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-cloud-upload"
                                      }),
                                      _vm._v(" Upload file\n                "),
                                      _c("input", {
                                        ref: "request_reviews",
                                        staticClass: "mt-2",
                                        attrs: {
                                          type: "file",
                                          accept:
                                            ".xls,.xlsx,.csv,.tsv,.ods,.slk,.xml"
                                        },
                                        on: { change: _vm.requestReviewsFile }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.uploadedFile && _vm.uploadedFile.length
                                    ? _c("span", { staticClass: "file-name" }, [
                                        _c("i", { staticClass: "fa fa-file" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.uploadedFile[0].name) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "span",
                                  { staticClass: "allowed-file-types mb-4" },
                                  [
                                    _vm._v(
                                      "\n                Allowed file types are: CSV, XLSX, TSV, ODS, SLK, ODM, XML.\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "file-rules mb-4" }, [
                                  _vm._v(
                                    "\n                File needs to contain 4 columns: first_name, last_name, email and phone.\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                Order of the columns is not important.\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                Phone number should be in 10 digit format with only numbers.\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                Last name is optional and can be blank.\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                Email or Phone is required. You can have one or the other, or both.\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "file-rules" }, [
                                  _vm._v("\n                Or you can "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "rules-link pl-1 pr-1",
                                      on: {
                                        click: function($event) {
                                          _vm.importingRequests = false
                                        }
                                      }
                                    },
                                    [_vm._v(" go back ")]
                                  ),
                                  _vm._v(" to add one by one.\n              ")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row m-0" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 d-flex flex-column justify-content-start p-0"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "check-field mb-2" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          class: [
                                            {
                                              "check-open": _vm.createCustomers
                                            }
                                          ]
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "checkmark"
                                          }),
                                          _vm._v(
                                            "Also create these customers and store them for selected Company\n                  "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.createCustomers,
                                                expression: "createCustomers"
                                              }
                                            ],
                                            staticClass: "btn-check",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: _vm.createCustomers,
                                              checked: Array.isArray(
                                                _vm.createCustomers
                                              )
                                                ? _vm._i(
                                                    _vm.createCustomers,
                                                    _vm.createCustomers
                                                  ) > -1
                                                : _vm.createCustomers
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = _vm.createCustomers,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = _vm.createCustomers,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.createCustomers = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.createCustomers = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.createCustomers = $$c
                                                }
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary send-button w-100 pull-right ld-ext-right",
                                      attrs: { type: "submit" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Send\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
                    ]
                  : _vm.requestLoading
                    ? [
                        _c("div", {
                          attrs: { slot: "header" },
                          slot: "header"
                        }),
                        _vm._v(" "),
                        _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-center justify-content-center mt-5"
                            },
                            [
                              _c("span", { staticClass: "loader-text" }, [
                                _vm._v("please wait")
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "loader-heading mb-3" },
                                [_vm._v("Request reviews are being imported.")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "loader" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { attrs: { slot: "footer" }, slot: "footer" })
                      ]
                    : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _c("h1", [_vm._v("Customers")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-primary",
        attrs: {
          type: "button",
          id: "dropdownMenuButton",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _vm._v("\n          Manage Customers\n          "),
        _c("i", { staticClass: "fa fa-caret-down pl-2" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bfc80ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bfc80ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customers/Customers.vue
// module id = null
// module chunks = 